export class ColonneSort
{
  directionSort: string = "";
  nameColonneSort: string = "";
}
